import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function StructuredNetwork() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
      <React.Fragment>
    <Meta
        title="Проектирование СКС - ИТ Особа"
        description="Профессиональное проектирование и прокладка структурированных кабельных систем для офиса, бизнес-центра или производства. Согласование, сертификация, гарантия на работы и материалы."
      />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          fontSize: '2.5em',
          color: '#34495e',
        }}
      >
        Проектирование и установка СКС
      </h1>

      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Создайте современную инфраструктуру — мы занимаемся проектированием и качественной установкой структурированных кабельных систем (СКС),
          обеспечивающих надежное и быстрое соединение в вашем офисе или дата-центре.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Что такое СКС?</h2>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Структурированная кабельная система (СКС) — это комплекс кабельных линий и оборудования,
          обеспечивающих передачу данных, голосовой связи и видеомониторинга внутри здания.
          Правильное проектирование и установка позволяют повысить эффективность работы сети и упростить ее обслуживание.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Преимущества наших решений</h2>

      <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontSize: '1.2em' }}>
        <li style={{ marginBottom: '10px' }}>Индивидуальный подход к проектированию под ваши потребности.</li>
        <li style={{ marginBottom: '10px' }}>Использование только качественных и сертифицированных материалов.</li>
        <li style={{ marginBottom: '10px' }}>Работаем быстро и аккуратно, минимизируя неудобства.</li>
        <li style={{ marginBottom: '10px' }}>Гарантия на выполненные работы и оборудование.</li>
        <li style={{ marginBottom: '10px' }}>Комплексное сопровождение: от проектирования до сдачи объекта.</li>
        <li style={{ marginBottom: '10px' }}>Конкурентные цены и прозрачная стоимость.</li>
        <li style={{ marginBottom: '10px' }}>Ответственная команда.</li>
      </ul>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        {/* <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button> */}
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}